/* moo-sur-mesure-leger.js : thème moood.fr (Sébastien 2026-10-22).
   Au-delà de quelques produits sur mesure, tout le panier passait à 0 € : l'app Option Price Calculator
   lâche quand le panier porte trop d'informations (testé : 5 lignes chargées = 0 €, 25 lignes allégées = prix justes).
   Chaque ligne sur mesure portait son détail 3 ou 4 fois (_data, _admin_summary, __ooCalcPayload, plus les
   propriétés visibles). On retire ces copies à l'ajout au panier ; restent les propriétés visibles (cotes,
   finition, prix) et __ooCustomPrice, le seul champ qui fixe le prix. Chargé en dernier : passe avant les autres filtres. */
(function () {
  if (window.__mooSmLeger) return;
  window.__mooSmLeger = true;
  var COPIES = ['_data', '_admin_summary', '__ooCalcPayload'];
  var allege = function (props) {
    if (!props || !props.__ooCustomPrice) return props;
    COPIES.forEach(function (k) { delete props[k]; });
    return props;
  };
  var _fetch = window.fetch;
  window.fetch = function (url, opts) {
    try {
      var u = typeof url === 'string' ? url : (url && url.url) || '';
      if (u.indexOf('/cart/add') !== -1 && opts && opts.body) {
        if (opts.body instanceof FormData) {
          if (opts.body.get('properties[__ooCustomPrice]')) COPIES.forEach(function (k) { opts.body.delete('properties[' + k + ']'); });
        } else if (typeof opts.body === 'string' && opts.body.charAt(0) === '{') {
          var b = JSON.parse(opts.body);
          if (b.items) b.items.forEach(function (it) { allege(it.properties); }); else allege(b.properties);
          opts.body = JSON.stringify(b);
        }
      }
    } catch (e) { /* en cas de doute : envoi tel quel */ }
    return _fetch.apply(this, arguments);
  };
  // ajout par formulaire classique (sans fetch) : on retire les champs avant l'envoi
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1 || !f.querySelector('[name="properties[__ooCustomPrice]"]')) return;
    COPIES.forEach(function (k) { var i = f.querySelector('[name="properties[' + k + ']"]'); if (i) i.disabled = true; });
  }, true);
})();
